export default __webpack_public_path__ + "static/automobile-76088d20c8e0236e7c6e73f94a735f13.jpg";